import React, { useState, useEffect } from 'react';
import { DownOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space } from 'antd';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { I18n } from 'react-redux-i18n';
import getEnvVariable from '../../utils/env';
import { getAuthToken } from '../../actions/auth';
import store from '../../store';

import './style.css';

const reactAppApiUrl = getEnvVariable('REACT_APP_API_URL');
const reactAppApiNewUrl = getEnvVariable('REACT_APP_API_NEW_URL');

const ExportButton = ({ options, paths, params, newApi = false }) => {
  const [items, setItems] = useState([]);

  const labels = {
    xls: 'XLS',
    ppt_short_version: I18n.t('negoce.filters.exportPPTShort'),
    ppt_long_version: I18n.t('negoce.filters.exportPPTLong')
  };

  const formatItems = () => {
    const PPTVersion = ['ppt_short_version', 'ppt_long_version'];

    return options.map((pres) => {
      const itemKey = pres;
      const itemType = PPTVersion.includes(pres) ? 'ppt' : pres;
      const itemPath = ['xls', 'ppt'].includes(itemType)
        ? paths[itemType]
        : null;

      let itemParams = {};
      if (params && params[itemType]) {
        itemParams = { ...params[itemType] };
      }
      if (itemType === 'ppt') {
        itemParams['version'] = itemKey.split('_')[1];
      }

      return {
        type: itemType,
        key: itemKey,
        label: labels[itemKey],
        path: itemPath,
        params: itemParams
      };
    });
  };

  useEffect(() => {
    let items = formatItems();
    setItems(items);
  }, [options, paths, params]);

  const getSelectItem = (key) => items.find((elem) => elem.key == key);

  const handleMenuClick = (e) => {
    let file = getSelectItem(e.key);
    exportFile(file);
  };

  const exportFile = (file) => {
    switch (file.type) {
      case 'xls':
        exportXls(file);
        break;
      case 'xlsx':
        exportXls(file);
        break;
      case 'ppt':
        exportPpt(file);
        break;
      default:
        break;
    }
  };

  const formatUrl = (path, params) => {
    let url = (newApi ? reactAppApiNewUrl : reactAppApiUrl) + path;
    if (params) {
      Object.keys(params).forEach((name) => {
        let hasParams = url.indexOf('?');
        if (params[name]) {
          url = `${url}${hasParams === -1 ? '?' : '&'}${name}=${params[name]}`;
        }
      });
    }
    return url;
  };

  const exportXls = async (file) => {
    let token = await getAuthToken();
    const clientToken = store.getState().auth.clientToken;
    if (clientToken) {
      token = clientToken;
    }
    let url = formatUrl(file.path, file.params);
    const response = await axios({
      headers: {
        Authorization: `Token ${token}`
      },
      responseType: 'blob',
      url: url,
      method: 'GET'
    });
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel'
    });

    if (response.headers['content-disposition']) {
      const headersName = response.headers['content-disposition']
        .split(`filename="`)[1]
        .split(`"`)[0];
      return saveAs(blob, headersName);
    }

    return saveAs(blob, name ? name + '.xls' : 'file.xls');
  };

  const exportPpt = async (file) => {
    let token = await getAuthToken();
    const clientToken = store.getState().auth.clientToken;
    if (clientToken) {
      token = clientToken;
    }

    let url = formatUrl(file.path, file.params);
    const response = await axios({
      headers: {
        Authorization: `Token ${token}`
      },
      responseType: 'blob',
      url: url,
      method: 'GET',
      maxRedirects: 0
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-powerpoint'
    });

    if (response.headers['content-disposition']) {
      const headersName = response.headers['content-disposition']
        .split(`filename="`)[1]
        .split('.')[0];
      return saveAs(blob, headersName + '.ppt');
    }
    const requestUrl = decodeURI(response.request.responseURL);
    if (requestUrl.includes('s3.amazon')) {
      let fileName = requestUrl.split('?')[0].split('/').slice(-1)[0];
      return saveAs(blob, fileName);
    }

    return saveAs(blob, name ? name + '.ppt' : 'file_1.ppt');
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick
      }}
      disabled={items.length === 0}
    >
      <Button
        type="primary"
        shape="round"
        icon={<DownloadOutlined className="download" />}
        className="export-button"
      >
        <Space>
          Export
          <DownOutlined className="icon-downout" />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default ExportButton;
